import { AvailableColumn } from '../../common/simple-table/simple-table.component';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CommonColumns: AvailableColumn[] = [
    {selected: true, field: {title: 'Owned', field: 'inventoryId', dataType: 'boolean', isInput: false}},
    {selected: true, field: {title: 'Name', field: 'name', dataType: 'string', isInput: false}},
    {selected: true, field: {title: 'Set', field: 'set', dataType: 'cardset', isInput: false}},
    {selected: true, field: {title: 'Mana Cost', field: 'manaCost', dataType: 'mana', isInput: false}},
    {selected: true, field: {title: 'Color Identity', field: 'colorIdentity', dataType: 'color', isInput: false}},
    {selected: true, field: {title: 'Type', field: 'type', dataType: 'string', isInput: false}},
    {selected: false, field: {title: 'Rarity', field: 'rarity', dataType: 'rarity', isInput: false}},
    {selected: false, field: {title: 'CMC', field: 'cmc', dataType: 'number', isInput: false}},
    {selected: false, field: {title: 'Scryfall ID', field: 'id', dataType: 'string', isInput: false}},
    {selected: false, field: {title: 'Set Name', field: 'setName', dataType: 'string', isInput: false}},
    {selected: false, field: {title: 'Artist', field: 'artist', dataType: 'string', isInput: false}},
    {selected: false, field: {title: 'Text', field: 'oracleText', dataType: 'string', isInput: false}}
];
